/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, SetStateAction, useState } from 'react';

import type { AgentSummary } from '@/hooks/useAIAgents';
import { useAutoDrawerStore } from '@/sections/insights/aiAssistant/stores/autoDrawer.store';
import type { HannibalLaunchConfig } from '@/sections/insights/aiAssistant/types/hunt.types';
import { localDateTimeInputToISOString } from '@/sections/insights/hunts/dateTimeLocal';
import { isHuntRootAgent } from '@/sections/insights/hunts/huntForm';

interface UseHuntModeProps {
  setNewMessage: Dispatch<SetStateAction<string>>;
  agents: AgentSummary[] | undefined;
  createHunt: (
    params: {
      prompt: string;
      expiresAt: string;
      finishCriteria?: string;
      guardrails?: string;
      agent?: string;
      allowedTools?: string[];
      scope?: string[];
    },
    options: { onSuccess: (hunt: any) => void }
  ) => void;
  isHuntPending: boolean;
}

export function useHuntMode({
  setNewMessage,
  agents,
  createHunt,
  isHuntPending,
}: UseHuntModeProps) {
  const [pendingMission, setPendingMission] = useState<string | null>(null);

  const huntAgents = (agents ?? []).filter(isHuntRootAgent);

  const handleHannibalLaunch = (config: HannibalLaunchConfig) => {
    createHunt(
      {
        prompt: config.mandate,
        expiresAt: localDateTimeInputToISOString(config.expiresAt),
        finishCriteria: config.finishCriteria || undefined,
        guardrails: config.guardrails || undefined,
        agent: config.agentName || undefined,
        allowedTools: undefined,
        scope: config.scope.length > 0 ? config.scope : undefined,
      },
      {
        onSuccess: (hunt: any) => {
          useAutoDrawerStore.getState().open(hunt.uuid);
          setPendingMission(null);
        },
      }
    );
  };

  const handleHannibalCancel = () => {
    setNewMessage(pendingMission ?? '');
    setPendingMission(null);
  };

  return {
    pendingMission,
    setPendingMission,
    handleHannibalLaunch,
    handleHannibalCancel,
    isHuntPending,
    huntAgents,
  };
}
